import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../supabase';

/**
 * Handles automatic redirection upon successful authentication events.
 * It prevents redirecting if the user is already on a protected route.
 */
const AuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      // Only explicitly redirect on brand new sign-ins or password recoveries.
      // Do not redirect on INITIAL_SESSION (which fires when tabs reload) or TOKEN_REFRESH (fires in background)
      if (event === 'SIGNED_IN' || event === 'PASSWORD_RECOVERY') {
        if (!session) return;

        const currentPath = window.location.pathname;

        // Only redirect to dashboard if we are explicitly on a public/auth page.
        const authPaths = ['/login', '/signup', '/'];

        // Do not redirect if the user is explicitly on a setup/recovery page
        const bypassPaths = ['/invited-setup', '/reset-password'];

        // Check for exact match
        const isAuthPath = authPaths.includes(currentPath);
        const isBypassPath = bypassPaths.includes(currentPath);

        const isTokenHash = window.location.hash.includes('access_token=') || window.location.hash.includes('refresh_token=');

        if ((isAuthPath || isTokenHash) && !isBypassPath) {
            const lastPath = localStorage.getItem('last_visited_path');
            navigate((lastPath && lastPath !== '/') ? lastPath : '/dashboard');
        }
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate, location]);

  return null;
};

export default AuthRedirect;
